import axios from "axios";

const API_POINT = process.env.REACT_APP_FORM_API_ROUTE;

const HTTPRequest = axios.create({
  baseURL: process.env.REACT_APP_FORM_API_URL,
});

export const GET_QUESTIONNAIRE = async (id, tenantId) => {
  //   const headers={
  //   "ngrok-skip-browser-warning": true
  // }
  try {
    const response = await HTTPRequest.get(
      `/${API_POINT}/${tenantId}/crai/render/${id}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching questionnaire:", error);
  }
};

export const SUBMIT_QUESTIONNAIRE_RESPONSE = async (sha, data, tenantId) => {
  //     const headers={
  //   "ngrok-skip-browser-warning": true
  // }
  try {
    const response = await HTTPRequest.post(
      `/mia/tenant/${tenantId}/submit/${sha}`,
      // `/${API_POINT}/${tenantId}/crai/submit/${id}`,
      data
    );

    return response;
  } catch (error) {
    console.error("Error submitting questionnaire response:", error);
  }
};

export const GET_QUESTIONNAIRE_CONTEXT = async ({ id = "", tenantId = "" }) => {
  //   const headers={
  //   "ngrok-skip-browser-warning": true
  // }
  try {
    const response = await HTTPRequest.get(
      `/${"assistants"}/${tenantId}/get_context/sessionid/${id}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching questionnaire:", error);
  }
};
export const INITIATE_CALL = async ({ payload = {}, tenantId = "" }) => {
  //   const headers={
  //   "ngrok-skip-browser-warning": true
  // }
  try {
    const response = await HTTPRequest.post(
      `/${"assistants"}/${tenantId}/call`,
      { ...payload },
      // { headers }
    );
    return response;
  } catch (error) {
    console.error("Error fetching questionnaire:", error);
  }
};

export const startVerifyOTP = async ({ phoneNumber = "" }) => {
  try {
    const response = await axios.post(
      "https://verify-9433-aubqel.twil.io/start-verify",
      new URLSearchParams({
        channel: "sms",
        locale: "en",
        to: phoneNumber,
      }),
      {
        headers: {
          accept: "*/*",
          "accept-language": "en-US,en;q=0.5",
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          origin: "https://verify-9433-aubqel.twil.io",
          priority: "u=1, i",
          referer: "https://verify-9433-aubqel.twil.io/index.html",
          "sec-ch-ua":
            '"Brave";v="143", "Chromium";v="143", "Not A(Brand";v="24"',
          "sec-ch-ua-mobile": "?0",
          "sec-ch-ua-platform": '"Windows"',
          "sec-fetch-dest": "empty",
          "sec-fetch-mode": "cors",
          "sec-fetch-site": "same-origin",
          "sec-gpc": "1",
          "user-agent":
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        },
      }
    );

    console.log("startVerifyOTP response:", response);
    return response;
  } catch (error) {
    console.error("Error starting OTP verification:", error);
    throw error;
  }
};

export const checkVerifyOTP = async ({ phoneNumber = "", code = "" }) => {
  try {
    const response = await axios.post(
      "https://verify-9433-aubqel.twil.io/check-verify",
      new URLSearchParams({
        to: phoneNumber,
        code: code,
      }),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Accept: "*/*",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error checking OTP verification:", error);
    throw error;
  }
};


/**
 * Create a session via the CRAI POC backend.
 * Returns { session_id, questionnaire_response } on success.
 */
export async function createSession({
  tenantId,
  formId,
  formUrl,
  form,
  agentName,
  patientName,
  dateOfBirth,
  patientGender,
  selectedLanguage,
  agentCode,
  prompt,
  mode,
  serviceConfig,
}) {
  const body = {
    form_id: formId,
  };
  if (formUrl) body.form_url = formUrl;
  if (form) body.form = form;
  if (agentName) body.agent_name = agentName;
  if (patientName) body.patient_name = patientName;
  if (dateOfBirth) body.date_of_birth = dateOfBirth;
  if (patientGender) body.patient_gender = patientGender;
  if (selectedLanguage) body.selected_language = selectedLanguage;
  if (agentCode) body.agent_code = agentCode;
  if (prompt) body.prompt = prompt;
  if (mode) body.mode = mode;
  if (serviceConfig) body.service_config = serviceConfig;

  // const baseURL =    "https://d496-125-17-254-110.ngrok-free.app"
  const baseURL =    " https://5ae3-125-17-254-110.ngrok-free.app"

  const res = await fetch(`${baseURL}/v1/crai-poc/${tenantId}/session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `HTTP ${res.status}`);
  }

  return res.json();
}

/**
 * Create a MIA session via the MIA backend.
 * Returns { session_id } on success.
 */
export async function createMiaSession({
  tenantId,
  formId,
  formUrl,
  mode,
  patientName,
  dateOfBirth,
  patientGender,
  agentName,
  selectedLanguage,
  serviceConfig,
}) {
  const body = {};
  if (formId) body.form_id = formId;
  if (formUrl) body.form_url = formUrl;
  if (mode) body.mode = mode;
  if (patientName) body.patient_name = patientName;
  if (dateOfBirth) body.date_of_birth = dateOfBirth;
  if (patientGender) body.patient_gender = patientGender;
  if (agentName) body.agent_name = agentName;
  if (selectedLanguage) body.selected_language = selectedLanguage;
  if (serviceConfig) body.service_config = serviceConfig;
  // const baseURL =    "https://d496-125-17-254-110.ngrok-free.app"
  // const baseURL =    "https://dea1-125-17-254-110.ngrok-free.app"

  const baseURL =    process.env.REACT_APP_FORM_API_URL
  // const baseURL =    "wss://demo.orie.ai/api/ai/v1"

  const res = await fetch(`${baseURL}/mia/${tenantId}/session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `HTTP ${res.status}`);
  }

  return res.json();
}

/**
 * Validate a set of questions via the MIA HTTP API.
 * Returns the same logical validation payload used by the
 * AI WebSocket validation (isValid, result, linkId, message, etc.).
 */
export async function validateQuestions({
  basePath,
  sessionId,
  questions,
  tenantId,
  timezone,
}) {
  const baseURL = process.env.REACT_APP_FORM_API_URL;
  const resolvedBasePath = basePath || `${baseURL}/mia`;

  const body = {
    questions,
    timezone,
  };
  if (sessionId) body.session_id = sessionId;

  const res = await fetch(`${resolvedBasePath}/${tenantId}/validate`, {
    method: "POST",
    headers: { 
      "Content-Type": "application/json", 
      // "ngrok-skip-browser-warning": true 
    },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `HTTP ${res.status}`);
  }

  return res.json();
}
